import { useEffect } from "react";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Sections/Home/Home";
import Demat from "./Sections/Demat/Demat";
import EasySteps from "./Sections/EasySteps/EasySteps";
import WhatYouGet from "./Sections/WhatYouGet/WhatYouGet";
import StockMarketMantra from "./Sections/StockMarketMantra/StockMarketMantra";
import Services from "./Sections/Services/Services";
import WGYC from "./Sections/WGYC/WGYC";
import AboutMe from "./Sections/AboutMe/AboutMe";
import Testimonial from "./Sections/Testimonials/Testimonial";
import ContactMe from "./Sections/ContactMe/ContactMe";
import AppBanner from "./Sections/AppBanner/AppBanner";
import Footer from "./Sections/Footer/Footer";
import SipCalculator from "./Sections/SipCalculator/SipCalculator";
import { Route, Routes } from "react-router-dom";
import Page404 from "./Sections/404/Page404";
import { SipNavItems, HomeNavItems, HomeDropdownNavItems, SipCalculatorDropdownNavItems, } from "./Components/Navbar/Data/NavItemsList";
import BottomQrPopup from "./Components/Popup/QrPopup";
import { emailjs_init } from "./Helper/EmailJs";
import { RoutesConstants } from "./Helper/RoutesConstants";
import Quote from "./Sections/Quote/Quote";
import { initGA, trackPageView } from "./Helper/Analytics";

function App() {
  useEffect(() => {
    const measurementId = process.env.REACT_APP_MEASUREMENT_ID;
    // Replace with your GA4 tracking ID
    initGA(measurementId);
  }, []);

  useEffect(() => {
    // Track page views when the route changes
    const handleRouteChange = () => {
      trackPageView(window.location.pathname);
    };

    // Listen for changes to the route
    window.addEventListener('popstate', handleRouteChange);

    // Track the initial page load
    handleRouteChange();

    // Clean up the event listener
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  useEffect(() => {
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    emailjs_init(publicKey);
  }, []);
  return (
    <>
      <Routes>
        <Route exact path={RoutesConstants.HOME} element={
          <>
            <Navbar isPrimary={false} navitems={HomeNavItems} dropdownNavitems={HomeDropdownNavItems} />
            <main>
              <Home />
              <Demat />
              <EasySteps />
              <WGYC />
              <WhatYouGet />
              <StockMarketMantra />
              <Services />
              <Quote />
              <AboutMe />
              <Testimonial />
              <ContactMe />
              <AppBanner />
              <Footer />
            </main>
          </>
        } />


        <Route path={RoutesConstants.SIP_CALCULATOR} element={
          <>
            <Navbar isPrimary={true} navitems={SipNavItems} dropdownNavitems={SipCalculatorDropdownNavItems} />
            <main>
              <SipCalculator />
              <ContactMe />
              <AppBanner />
              <Footer />
            </main>
          </>
        } />

        <Route path={RoutesConstants.UNKNOWN} element={
          <>
            <Navbar isPrimary={true} navitems={SipNavItems} dropdownNavitems={HomeDropdownNavItems} />
            <Page404 />
          </>
        } />

      </Routes>

      <BottomQrPopup />
    </>
  );
}

export default App;
